import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Stack, Typography, IconButton } from '@mui/material';

import { blueGradientButton } from '../../../../assets/styles/blueGradientButton.style';

interface PageControllerProps {
  page: number;
  setPage: (page: number) => void;
  totalPage: number;
}

const PageController = ({ page, setPage, totalPage }: PageControllerProps) => {

  const nextPagehandler = () => {
    if (page < totalPage) {
      setPage(page + 1);
    }
  };

  const prevPageHandler = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Typography sx={{
        fontFamily:'Schibsted Grotesk, sans-serif',
        fontSize: '16px',
        fontWeight: 400,
        color: '#878787',
        lineHeight: '125%',
      }}>
          Step {page} of {totalPage}
      </Typography>
      <Stack direction='row' alignItems='center' gap={1}>
        <Typography sx={{
          fontFamily:'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
        }}>
            Skip for now
        </Typography>
        <IconButton 
          disabled={page === 1}
          onClick={prevPageHandler}
          sx={{
            ...blueGradientButton,
            borderRadius: '6px',
            height:'40px',
            width:'40px',
          }}>
          <KeyboardArrowUpIcon />
        </IconButton>
        <IconButton 
          disabled={page === totalPage}
          onClick={nextPagehandler}
          sx={{
            ...blueGradientButton,
            borderRadius: '6px',
            height:'40px',
            width:'40px',
          }}>
          <KeyboardArrowDownIcon />
        </IconButton>
      </Stack>
      
    </Stack>
  );
};

export default PageController;